import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root', })
export class ContactCenterService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiOperationsNetwork/" + nameMethod, data, HEADERS);

  // getContactCenterOperations() Obtiene información de la planta telefónica del contact center
  getContactCenterOperations = (data: FormData): Observable<any> => this.request(data, "getContactCenterOperations");

  // getContactCenterRecoveries() Obtiene información de las recuperaciones por asesor
  getContactCenterRecoveries = (data: FormData): Observable<any> => this.request(data, "getContactCenterRecoveries");

  // getContactCenterRefunds() Obtiene información de los reintegros
  getContactCenterRefunds = (data: FormData): Observable<any> => this.request(data, "getContactCenterRefunds");

  // getContactCenterReports() Obtiene información de la planta telefónica del contact center para reportes
  getContactCenterReports = (data: FormData): Observable<any> => this.request(data, "getContactCenterReports");

  // importMassiveRefunds() Envía el archivo de reintegros al API para ingresarlos de forma masiva
  importMassiveRefunds = (data: FormData): Observable<any> => this.request(data, "importMassiveRefunds");

  // getCPCReport(): Servicio para obtener información de Recaudo Canales de Pago
  getCPCReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
